export default [{
    name: 'base',
    data: {},
    items: [
        { name: 'googleHomeLedMaskTexture', source: '/assets/googleHomeLedMask.png', type: 'texture' },
        { name: 'googleHomeLedsModel', source: '/assets/googleHomeLedsModel.glb', type: 'model' },

        { name: 'loupedeckButtonsModel', source: '/assets/loupedeckButtonsModel.glb', type: 'model' },

        { name: 'topChairModel', source: '/assets/topChairModel.glb', type: 'model' },

        { name: 'coffeeSteamModel', source: '/assets/coffeeSteamModel.glb', type: 'model' },

        { name: 'elgatoLightModel', source: '/assets/elgatoLightModel.glb', type: 'model' },

        { name: 'threejsJourneyLogoTexture', source: '/assets/HoussemLachtarLogo.png', type: 'texture' },

        { name: 'pcScreenModel', source: '/assets/pcScreenModel.glb', type: 'model' },

        { name: 'macScreenModel', source: '/assets/macScreenModel.glb', type: 'model' },

        { name: 'bakedDayTexture', source: '/assets/bakedDay.jpg', type: 'texture' },
        { name: 'bakedNightTexture', source: '/assets/bakedNight.jpg', type: 'texture' },
        { name: 'bakedNeutralTexture', source: '/assets/bakedNeutral.jpg', type: 'texture' },
        { name: 'lightMapTexture', source: '/assets/lightMap.jpg', type: 'texture' },
        { name: 'roomModel', source: '/assets/roomModel.glb' },
    ]
}]